import { atom } from 'jotai'

const isMobileAtom = atom(window.matchMedia('(max-width: 850px)').matches)
export default isMobileAtom
